<template>
    <div>
        <span v-if="disabled && printMode" class="showText">{{ showValue }}</span>
        <template v-else-if="mode == 'normal'">
            <el-input ref="main" :placeholder="$t(placeholder)" :value="showValue" :size="size"
                :clearable="disabled ? false : clearable" :disabled="disabled" @clear="handleInputClear"
                @focus="handleShow">
                <span slot="append" @click="handleShow">
                    <el-button slot="append" icon="el-icon-user"></el-button>
                </span>
                <template slot="prepend" v-if="canSelectCurrent && !disabled">
                    <div class="flex pointer" style="justify-content: center;height: 100%;" :title="$t(currentName)"
                        @click="selectCurrent">
                        <i class="learun-icon-lock" :style="{ 'color': hasCurrent ? '#409eff' : '#8c8c8c' }"></i>
                    </div>
                </template>
            </el-input>
        </template>
        <template v-else-if="mode == 'form'">
            <div class="flex" style="flex-wrap: wrap;">
                <div class="add-btn" style="
                    width: auto;
                    padding: 0 12px;
                    display: inline-block;
                    font-size: 12px;
                    color: #2c71fa;
                    background: #f5f7f9;
                    height: 28px;
                    line-height: 28px;
                    border-radius: 14px;
                    margin: 4px 0;
                    margin-right: 8px;
                    cursor: pointer;" v-if="!disabled" @click="handleShow">
                    <i class="el-icon-plus"></i>
                    {{ $t('添加人员') }}
                </div>
                <template v-for="i in uids.slice(0, max)">
                    <l-userItem :canRemove="disabledRemove.indexOf(i) == -1 && !disabled" :size="28" mode="form"
                        @remove="removeHandler" :uid="i" :key="i" />
                    <slot name="right" v-bind="{ id: i }"></slot>
                </template>

                <span v-if="uids.length > max" @click="$refs.userSelectDg.show('6')"
                    class="pointer">等{{ uids.length }}人</span>
            </div>
        </template>
        <template v-else-if="mode == 'tag'">
            <div class="flex tag-mode" @click="handleShow" :style="{'border-width': showBorder ? '1px':'0px'}">
                <!-- <div class="add-btn" style="
                    width: auto;
                    padding: 0 12px;
                    display: inline-block;
                    font-size: 12px;
                    color: #2c71fa;
                    background: #f5f7f9;
                    height: 28px;
                    line-height: 28px;
                    border-radius: 14px;
                    margin: 4px 0;
                    margin-right: 8px;
                    cursor: pointer;" v-if="!disabled" @click="handleShow">
                    <i class="el-icon-plus"></i>
                    {{ $t('添加人员') }}
                </div> -->
                <template v-for="i in uids.slice(0, 10)" v-if="uids.length > 0">
                    <l-userItem :canRemove="disabledRemove.indexOf(i) == -1 && !disabled" :size="22" mode="form"
                        @remove="removeHandler" :isTag="true" :uid="i" :key="i"  />
                    <slot name="right" v-bind="{ id: i }"></slot>
                </template>
                <div class="tishi" v-if="showPlaceholder && uids.length == 0">
                    <i class="el-icon-plus" style="font-size: 13px;margin-right: 2px;"></i>
                    <span style="font-size: 12px;">请选择人员</span>
                </div>

                <span v-if="uids.length > 10" @click="$refs.userSelectDg.show('6')"
                    class="pointer">等{{ uids.length }}人</span>
            </div>
        </template>
        <template v-else-if="mode == 'btn'">
            <slot name="btn" :handleShow="handleShow"></slot>
        </template>
        <l-user-select-dg ref="userSelectDg" :loadadd="loadadd" :disabledList="disabledList" :title="placeholder"
            :multiple="multiple" :value="uidStr" @save="handleSelectMultiple">
        </l-user-select-dg>
    </div>
</template>

<script>
export default {
    name: 'l-user-select',
    props: {
        value: {},
        size: {
            default: 'mini'
        },
        placeholder: {
            type: String,
            default: '请选择'
        },

        disabled: {
            type: Boolean,
            default: false
        },
        printMode: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        sidx: {
            type: String,
            default: 'F_CreateDate DESC'
        },
        mode: {
            default: 'tag', //onlyDg 只需要弹窗
        },
        disabledRemove: {
            default: '' //禁止移除的成员id字符串
        },
        disabledList: {
            default: ''
        },
        canSelectCurrent: {
            default: false // 是否可选当前用户
        },
        loadadd: {

        },
        showBorder: {
            default: true
        },
        showPlaceholder: {
            default: true
        },
        max: {
            default: 10
        }
    },
    data() {
        return {
            isInit: false,
            value2: '',
            currentName: '登录用户'
        }
    },
    computed: {
        showValue() {
            let arr = this.value ? this.value.split(',') : [], brr = []
            if (arr.includes(this.currentName)) {
                brr.push(this.$t(this.currentName))
            }
            if (this.lr_userName) {
                brr = brr.concat(this.lr_userName(arr.filter(e => e != this.currentName).join(',')))
            }
            else {
                return this.value
            }
            return brr.filter(e => e).join(',')
        },
        uids() {
            return this.value ? this.value.split(',') : []
        },
        hasCurrent() {
            if (!this.value) return false
            return this.value.indexOf(this.currentName) > -1
        },
        uidStr() {
            if (!this.value) return ''
            return this.value.replace(`${this.currentName},`, '').replace(this.currentName, '')
        }
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) newVal = newVal.replace(`${this.currentName},`, '').replace(this.currentName, '')
                if (this.$validatenull(newVal)) {
                    this.isInit = false
                }
                else {
                    this.lr_loadUsers && this.lr_loadUsers(newVal)
                }
            },
            immediate: true
        }
    },
    created() {
    },
    methods: {
        getVal() {
            return
        },
        focus() {
            this.$refs.main && this.$refs.main.focus()
        },
        handleInputClear() {
            this.value2 = ''
            this.$emit('input', this.value2)
            this.handleChange()
        },
        removeHandler(user) {
            let arr = this.value ? this.value.split(',') : []
            arr = arr.filter(e => e != user.uid)
            this.value2 = arr.join(',')
            this.$emit('input', this.value2)
            this.handleChange(this.value2)
        },
        handleChange(val) {
            this.$emit('change', val)
            this.dispatch("ElFormItem", "el.form.blur", val);
            this.dispatch("ElFormItem", "el.form.change", val);
        },
        handleShow() {
            if (!this.disabled) {
                this.$refs.userSelectDg.show()
            }
        },
        selectCurrent() {
            let arr = this.value ? this.value.split(',') : []
            if (arr.includes(this.currentName)) {
                arr = arr.filter(e => e != this.currentName)
            } else {
                if (this.multiple) {
                    arr.unshift(this.currentName)
                } else {
                    arr = [this.currentName]
                }
            }
            let val = arr.join(',')
            this.$emit('input', val)
            this.$emit('change', val)
        },
        handleSelectMultiple({ val, selectedList }) {
            if (this.hasCurrent) {
                let arr = val ? val.split(',') : []
                arr.unshift(this.currentName)
                val = arr.join(',')
            }
            this.value2 = val
            this.$emit('input', val)
            let arr = val ? val.split(',') : []
            arr = arr.map(e => {
                return this.getUserInfo(e)
            })
            this.$emit('select', arr)
            this.$refs.main && this.$refs.main.focus()
            this.$refs.main && this.$refs.main.blur()

            if (selectedList.length == 0) {
                this.handleChange('')
            }
            else {
                this.handleChange(selectedList)
            }

        }
    }
}
</script>
<style lang="less" scoped>
.tishi {
    height: 20px;
    line-height: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.add-btn {
    width: auto;
    padding: 0 12px;
    display: inline-block;
    font-size: 12px;
    color: #2c71fa;
    background: #f5f7f9;
    height: 28px;
    line-height: 28px;
    border-radius: 14px;
    margin: 4px 0;
    margin-right: 8px;
    cursor: pointer;
}

.tag-mode {
    flex-wrap: wrap;
    border: 1px dashed #bfbfbf;
    border-radius: 4px;
    height: 28px;
    cursor: pointer;
    padding: 2px 3px;
    overflow-y: auto;
    overflow-x: hidden;
    gap: 4px;
    .add-btn {

    }

}
::v-deep {
    .tag-mode {
        .remove-btn {
            transform: scale(0.8);
            top: -15px;
            line-height: 28px;
        }
        .tag-item.isForm {
            height: unset !important;
            margin: 0;
            border-radius: 3px;
            padding-left: 5px;
        }
        .tag-item .name {
            padding-right: 0;
            line-height: 22px;
        }
        .tag-right {
            line-height: 22px;
            width: unset !important;
        }
        .tag-item .avatar {
            margin-right: 4px;
        }
    }
    
}
</style>